export default __webpack_public_path__ + "static/media/sassC.37c8c827.webp";